import { Form, Input, Modal } from "antd";
import { useEffect } from "react";
import { asyncUpdateFeeses } from "../../../../store/renewal/renewal-async";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { setCommon } from "../../../../store/common/common-slice";

interface IMtmModal {
  open: boolean;
  setOpen: (value: boolean) => void;
  record: IObject | null;
  fetchData: () => void;
}

const mtmFeeFields = [
  { key: "mtm_media_package", label: "Media Package" },
  { key: "mtm_pet_fee", label: "Pet Fee" },
  { key: "mtm_garage_income", label: "Garage Income" },
  { key: "mtm_income", label: "MTM Income" },
  { key: "mtm_ami", label: "Garden Box Fees" },
  { key: "mtm_bike", label: "Bike Fees" },
  { key: "mtm_eccs", label: "EV Stall Fees" },
  { key: "mtm_hoa", label: "HOA Fees" },
  { key: "mtm_insw", label: "Insurance Waiver Fees" },
  { key: "mtm_pss", label: "Parking Surface Stall Fees" },
  { key: "mtm_short", label: "Short Term Lease Fees" },
  { key: "mtm_stor", label: "Storage Fees" },
];

const MtmModal = ({ open, setOpen, record, fetchData }: IMtmModal) => {
  const [form] = Form.useForm();
  const { loading } = useAppSelector((s) => s.common);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (open && record) {
      form.setFieldsValue({ ...record });
    }
  }, [open, record?.pk_id]);

  const onCreate = async (values: IObject) => {
    try {
      dispatch(setCommon({ loading: true }));
      const obj = { ...values, pk_id: record!.pk_id, type: "mtm" };
      await dispatch(asyncUpdateFeeses(obj));
      setOpen(false);
      fetchData();
    } catch (err: any) {
      console.error(err);
    } finally {
      dispatch(setCommon({ loading: false }));
    }
  };

  return (
    <Modal
      open={open}
      okText={loading ? "Updating..." : "Update"}
      okButtonProps={{ disabled: loading }}
      cancelText="Cancel"
      cancelButtonProps={{ disabled: loading }}
      onCancel={() => setOpen(false)}
      onOk={() => form.validateFields().then(onCreate).catch(console.log)}
    >
      <Form form={form} layout="horizontal" preserve={false} disabled={loading}>
        {mtmFeeFields
          .filter((f) => record && f.key in record)
          .map((field) => (
            <Form.Item
              key={field.key}
              name={field.key}
              label={field.label}
              rules={[
                { required: true, message: `Please input ${field.label}` },
              ]}
            >
              <Input />
            </Form.Item>
          ))}
      </Form>
    </Modal>
  );
};

export default MtmModal;